"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./version");
tslib_1.__exportStar(require("@uifabric/styling"), exports);
//# sourceMappingURL=Styling.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Styling.js
// module id = 463
// module chunks = 0